var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakePhotoCircle = function SvgTakePhotoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#fff",
    fillOpacity: 0.3,
    rx: 36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 6,
    y: 6,
    fill: "#fff",
    rx: 30
  })));
};
export default SvgTakePhotoCircle;